const Videos = [
{
url: 'https://www.youtube.com/embed/euo8Ao0KWQo?si=rvkyQSUQphbn5_Kk&amp;controls=0',
cover: 'cuentos-1',
group: 'cuentos'
}
,{
url: 'https://www.youtube.com/embed/35LRfDhD0bY?si=2q2bjI-NbMM51nPw&amp;controls=0',
cover: 'cuentos-2',
group: 'cuentos'
}
,{
  url: 'https://www.youtube.com/embed/N1xIPwM0W-Q?si=jxufcMVNdXZa8vpF&amp;controls=0',
  cover: 'cuentos-3',
  group: 'cuentos'
}
,{
  url: 'https://www.youtube.com/embed/orLtLtc-RQg?si=ACO-fCV37EOfs28y&amp;controls=0',
  cover: 'cuentos-5',
  group: 'cuentos'
}
,{
  url: 'https://www.youtube.com/embed/Fa0tpxOmITI?si=LXKzgzSzbuuNZY9y&amp;controls=0',
  cover: 'blaze-1',
  group: 'blaze'
}
,{
  url: 'https://www.youtube.com/embed/bXnzNI6cW5A?si=zLqlsYn4buSeVJyF&amp;controls=0',
  cover: 'blaze-2',
  group: 'blaze'
}
,{
  url: 'https://www.youtube.com/embed/jVHG7JifKlY?si=RDLfTIM8uhR8kjpJ&amp;controls=0',
  cover: 'blaze-3',
  group: 'blaze'
}
,{
  url: 'https://www.youtube.com/embed/BqE9dcfh_-c?si=FQ-LP0zIAN78aVgl&amp;controls=0',
  cover: 'blaze-4',
  group: 'blaze'
}
,{
  url: 'https://www.youtube.com/embed/pzplSEmVsZ0?si=Y6JDCGRK6XRFIZaq&amp;controls=0',
  cover: 'blaze-5',
  group: 'blaze'
}
,{
  url: 'https://www.youtube.com/embed/TUlay--1ATQ?si=mufk5crojCxhU9gA&amp;controls=0',
  cover: 'pequenos-heroes-1',
  group: 'pequenos-heroes'
}
,{
  url: 'https://www.youtube.com/embed/kLyGRfd_6Zs?si=mtBuhl-Gnf3TPezo&amp;controls=0',
  cover: 'pequenos-heroes-2',
  group: 'pequenos-heroes'
}
,{
  url: 'https://www.youtube.com/embed/WmLls6zICrA?si=f0mLf2fCWaPZ0UyM&amp;controls=0',
  cover: 'pequenos-heroes-3',
  group: 'pequenos-heroes'
}
,{
  url: 'https://www.youtube.com/embed/GuJicJyBp7Q?si=Bb6IF6poFQfoiI7Z&amp;controls=0',
  cover: 'pequenos-heroes-4',
  group: 'pequenos-heroes'
}
,{
  url: 'https://www.youtube.com/embed/cj9jvNLO6jo?si=2ra4tBGjoiecPG0v&amp;controls=0',
  cover: 'pequenos-heroes-5',
  group: 'pequenos-heroes'
}
,{
  url: 'https://www.youtube.com/embed/sihr2zLnLcQ?si=AW12rDAPHF_Pb418&amp;controls=0',
  cover: 'pequenos-heroes-6',
  group: 'pequenos-heroes'
}
,{
  url: 'https://www.youtube.com/embed/eprtDGbl7-c?si=nf6nBCV-pbYhSV0j&amp;controls=0',
  cover: 'pequenos-heroes-7',
  group: 'pequenos-heroes'
}
,{
  url: 'https://www.youtube.com/embed/4err2bxP15M?si=WG3ceOKixgw4fqZs&amp;controls=0',
  cover: 'pequenos-heroes-8',
  group: 'pequenos-heroes'
}
,{
  url: 'https://www.youtube.com/embed/r47yUmJjotk?si=YDQ1hhfKpPSe6q27&amp;controls=0;start=5',
  cover: 'cars-1',
  group: 'cars'
}
,{
  url: 'https://www.youtube.com/embed/O7a1tVm66hU?si=nkm-1PCUhhiSAjP-&amp;controls=0&amp;start=5',
  cover: 'cars-2',
  group: 'cars'
}
,{
  url: 'https://www.youtube.com/embed/_vRqwEbzf7A?si=UDmAOuKdwYrd27MN&amp;controls=0',
  cover: 'super-libro-1',
  group: 'super-libro'
}
,{
  url: 'https://www.youtube.com/embed/DZTWoBa148E?si=5gy8eXYhRCzx9ica&amp;controls=0',
  cover: 'super-libro-2',
  group: 'super-libro'
}
,{
  url: 'https://www.youtube.com/embed/HKZxQLlfTlc?si=nJxTUqU3TdIjlm-1&amp;controls=0',
  cover: 'super-libro-3',
  group: 'super-libro'
}
,{
  url: 'https://www.youtube.com/embed/ujVJNiyUxsg?si=GnxtcIY2cT_q1N-_&amp;controls=0',
  cover: 'super-libro-4',
  group: 'super-libro'
}
,{
  url: 'https://www.youtube.com/embed/RK55zFKMH8k?si=iBmZ_jSz7le8PUxe&amp;controls=0',
  cover: 'super-libro-5',
  group: 'super-libro'
}
,{
  url: 'https://www.youtube.com/embed/XcFKVjPLJw0?si=8vC4S88kdMYy7wxZ&amp;controls=0',
  cover: 'super-libro-6',
  group: 'super-libro'
}
,{
  url: 'https://www.youtube.com/embed/YdB9DyjkuuM?si=vc_OuqDZQe9HL96R&amp;controls=0',
  cover: 'cars-3',
  group: 'cars'
}
,{
  url: 'https://www.youtube.com/embed/ZsdWJOoZAPg?si=lJ4tMfrQZl3OJ3PB&amp;controls=0',
  cover: 'paw-patrol-1',
  group: 'paw-patrol'
}
,{
  url: 'https://www.youtube.com/embed/KKsySBlm36I?si=fC_KfBzXuWtpCoxa&amp;controls=0',
  cover: 'paw-patrol-2',
  group: 'paw-patrol'
}
,{
  url: 'https://www.youtube.com/embed/OC76Kyk3IRU?si=PLRWYGQQNnb3gShN&amp;controls=0',
  cover: 'paw-patrol-3',
  group: 'paw-patrol'
}
,{
  url: 'https://www.youtube.com/embed/GetAwMNY2kY?si=sB2PCJHkIDF8rRn_&amp;controls=0',
  cover: 'paw-patrol-4',
  group: 'paw-patrol'
}
,{
  url: 'https://www.youtube.com/embed/7vNuNS59u9A?si=1sS-OTG-EnaF6Vqf&amp;controls=0',
  cover: 'paw-patrol-5',
  group: 'paw-patrol'
}
,{
  url: 'https://www.youtube.com/embed/BQEaoLpVYC4?si=XBCyrYPmCcWJpfnz&amp;controls=0',
  cover: 'paw-patrol-6',
  group: 'paw-patrol'
}
,{
  url: 'https://www.youtube.com/embed/bK-7IYBUkyQ?si=4EIlXclIJx-bUK0M&amp;controls=0',
  cover: 'paw-patrol-7',
  group: 'paw-patrol'
}
,{
  url: 'https://www.youtube.com/embed/SeAfi6pK4EA?si=JzAQjM7utd83QuV0&amp;controls=0',
  cover: 'paw-patrol-8',
  group: 'paw-patrol'
}
,{
  url: 'https://www.youtube.com/embed/8hdHJL7ImYQ?si=wWUyQ-6PzE3lgIlo&amp;controls=0',
  cover: 'paw-patrol-9',
  group: 'paw-patrol'
}
,{
  url: 'https://www.youtube.com/embed/dJ_pa8lkSsg?si=0Fd4MqjH_ZaydJpL&amp;controls=0',
  cover: 'paw-patrol-10',
  group: 'paw-patrol'
}
,{
  url: 'https://www.youtube.com/embed/Bs2wcbueHe4?si=R5ZNNASDpzjSumhS&amp;controls=0',
  cover: 'paw-patrol-11',
  group: 'paw-patrol'
}
,{
  url: 'https://www.youtube.com/embed/KAI-6zssI5s?si=SSzdSgSUCEXngK5R&amp;controls=0',
  cover: 'paw-patrol-12',
  group: 'paw-patrol'
}
,{
  url: 'https://www.youtube.com/embed/X-RT5FhBs10?si=4VpWzLBuYMZ0_ywr&amp;controls=0',
  cover: 'paw-patrol-13',
  group: 'paw-patrol'
}
,{
  url: 'https://www.youtube.com/embed/eEPejK66O5s?si=QDkf7fSmcjgV2yhb&amp;controls=0',
  cover: 'paw-patrol-14',
  group: 'paw-patrol'
}
,{
  url: 'https://www.youtube.com/embed/g3oDFaqQlOI?si=Qlv-ubmVMwv44svw&amp;controls=0',
  cover: 'paw-patrol-15',
  group: 'paw-patrol'
}
,{
  url: 'https://www.youtube.com/embed/ANRBY_BWmB0?si=v5goV0eypH08Xzzs&amp;controls=0',
  cover: 'cars-4',
  group: 'cars'
}
,{
  url: 'https://www.youtube.com/embed/M81OwAk5Ixk?si=mbOlDA-eXb1xWDfM&amp;controls=0',
  cover: 'cars-5',
  group: 'cars'
}
,{
  url: 'https://www.youtube.com/embed/aH-HotoRxUk?si=JlnqMzHL0CWy0CMJ&amp;controls=0',
  cover: 'cars-6',
  group: 'cars'
}
,{
  url: 'https://www.youtube.com/embed/ThzNGpm5s1s?si=ESHXozQd9IAun5ek&amp;controls=0',
  cover: 'cuentos-6',
  group: 'cuentos'
}
,{
  url: 'https://www.youtube.com/embed/NzhviSRpkqw?si=tHZJqMmVGKWDVy26&amp;controls=0',
  cover: 'cuentos-7',
  group: 'cuentos'
}
,{
  url: 'https://www.youtube.com/embed/6K3-7trzEVE?si=FuPjSkEYJi1rduc5&amp;controls=0',
  cover: 'cuentos-8',
  group: 'cuentos'
}
,{
url: 'https://www.youtube.com/embed/3w0Uk_ToydY?si=964qNjlIdh5aj6TZ&amp;controls=0',
cover: 'cuentos-9',
group: 'cuentos'
}
,{
url: 'https://www.youtube.com/embed/6GxaLFDTYKQ?si=24id9TsF3xlydpHC&amp;controls=0',
cover: 'cuentos-10',
group: 'cuentos'
}
,{
url: 'https://www.youtube.com/embed/mhi7Q7sjop4?si=LrYR0bvlBq697AmP&amp;controls=0',
cover: 'paw-patrol-16',
group: 'paw-patrol'
}
,{
url: 'https://www.youtube.com/embed/ZK296luxJQg?si=63-3m-Y9BVnrTFY6&amp;controls=0',
cover: 'paw-patrol-17',
group: 'paw-patrol'
}
,{
url: 'https://www.youtube.com/embed/eUDWVLLXUe8?si=Vln-F_AHK1BIR4qq&amp;controls=0',
cover: 'paw-patrol-18',
group: 'paw-patrol'
}
,{
url: 'https://www.youtube.com/embed/GetAwMNY2kY?si=azw-9fAWDhUtKvdJ&amp;controls=0',
cover: 'paw-patrol-19',
group: 'paw-patrol'
}
,{
url: 'https://www.youtube.com/embed/e8tqOCOTRR8?si=8do9zosJ0Ywo163G&amp;controls=0',
cover: 'paw-patrol-20',
group: 'paw-patrol'
}
,{
url: 'https://www.youtube.com/embed/NqPxC7YLdfM?si=qdRMIhvqGC_AfLQT&amp;controls=0',
cover: 'paw-patrol-21',
group: 'paw-patrol'
}
,{
url: 'https://www.youtube.com/embed/_iuGNQrc7cw?si=iSIEaamtk4WHigWe&amp;controls=0',
cover: 'paw-patrol-22',
group: 'paw-patrol'
}
,{
url: 'https://www.youtube.com/embed/uzKHfXFomdI?si=d4SkWwEfYhqiN84g&amp;controls=0',
cover: 'paw-patrol-23',
group: 'paw-patrol'
}
,{
url: 'https://www.youtube.com/embed/j-tvkROIBWw?si=5xuqLzLSnof_zMPz&amp;controls=0',
cover: 'blaze-7',
group: 'blaze'
}
,{
url: 'https://www.youtube.com/embed/dNmVBdrv6dI?si=lve3usqVw56q44ga&amp;controls=0',
cover: 'blaze-6',
group: 'blaze'
}
,{
url: 'https://www.youtube.com/embed/CjMSx7PVp24?si=4M9UaNQbZwUGB8V2&amp;controls=0',
cover: 'super-libro-7',
group: 'super-libro'
}
,{
url: 'https://www.youtube.com/embed/0HssHyuEXvI?si=ps7QW4JZiAFqvH-G&amp;controls=0',
cover: 'super-libro-8',
group: 'super-libro'
}
,{
url: 'https://www.youtube.com/embed/HZlegJPijcU?si=Ti7QzSC2WaWgCCbp&amp;controls=0',
cover: 'super-libro-9',
group: 'super-libro'
}
,{
url: 'https://www.youtube.com/embed/s5skboxbipg?si=VasCxJ5O0QtUWuud&amp;controls=0',
cover: 'super-libro-10',
group: 'super-libro'
}
,{
url: 'https://www.youtube.com/embed/8EpOvP3kCio?si=FviFUfjPXTeHdIuD&amp;controls=0',
cover: 'super-libro-11',
group: 'super-libro'
}
,{
url: 'https://www.youtube.com/embed/pvbsmiIOKIc?si=VsaBiIsJ79BWRJTo&amp;controls=0',
cover: 'super-libro-12',
group: 'super-libro'
}
,{
url: 'https://www.youtube.com/embed/Sv3qphmN4Zo?si=eH3ykev7KeFoWwgy&amp;controls=0',
cover: 'super-libro-13',
group: 'super-libro'
}
,{
url: 'https://www.youtube.com/embed/9CEU8BEUqY4?si=R5JOQzraSBSqpUMW&amp;controls=0',
cover: 'super-libro-14',
group: 'super-libro'
}
,{
url: 'https://www.youtube.com/embed/uduqW8EURzM?si=foDIAjRzv1QtT6dl&amp;controls=0',
cover: 'super-libro-15',
group: 'super-libro'
}
,{
url: 'https://www.youtube.com/embed/VBMw3RdzRzs?si=2aO3qYugJwjnQY-n&amp;controls=0',
cover: 'super-libro-16',
group: 'super-libro'
}
,{
url: 'https://www.youtube.com/embed/HiLEq0WdVmI?si=E-Td3fNK9f0BYZTv&amp;controls=0',
cover: 'super-libro-17',
group: 'super-libro'
}
,{
url: 'https://www.youtube.com/embed/zOHh6NOKkKE?si=P8WWkA0sbD_QG_3f&amp;controls=0',
cover: 'super-libro-18',
group: 'super-libro'
}
,{
url: 'https://www.youtube.com/embed/3nXvPXADl6A?si=tT0s7DoOCBAogz7S&amp;controls=0',
cover: 'cuentos-11',
group: 'cuentos'
}
,{
url: 'https://www.youtube.com/embed/Hq3UAK3u3QM?si=jVTdLhaTK7bXEahR&amp;controls=0',
cover: 'cuentos-12',
group: 'cuentos'
}
,{
url: 'https://www.youtube.com/embed/erImv5PJqnA?si=8lWfyXuRoTMRZYq4&amp;controls=0',
cover: 'cuentos-4',
group: 'cuentos'
}
,{
url: 'https://www.youtube.com/embed/afX7kwUAhSE?si=zJjjzobg9NjDwhZm&amp;controls=0',
cover: 'mario-2',
group: 'mario'
}
,{
url: 'https://www.youtube.com/embed/VHovNBF5L6g?si=f2Mahx5xHvQmhlor&amp;controls=0',
cover: 'mario-3',
group: 'mario'
}
,{
url: 'https://www.youtube.com/embed/D-uvIv8dOc4?si=N73BuB4naQK19Rk2&amp;controls=0',
cover: 'mario-4',
group: 'mario'
}
,{
url: 'https://www.youtube.com/embed/xCoztFfStBE?si=fLC1l5r1xHSzAVa2&amp;controls=0',
cover: 'super-friends-movie',
group: 'super-friends'
}













];
  
  export default Videos;